import React, { useRef } from 'react';
import { DropTarget, DragSource } from 'react-dnd';

const CARD = 'card';

const CardDndComponent = (props) => {
  const { isDragging, connectDragSource, connectDropTarget } = props;
  const opacity = isDragging ? 0 : 1;
  const ref = useRef(null);
  connectDragSource(ref);
  connectDropTarget(ref);
  return (
    <div ref={ref} style={{ opacity }}>
      {props.children}
    </div>
  );
};

export default DropTarget(
  CARD,
  {
    canDrop: () => false,
    hover(props, monitor) {
      const { id: draggedId } = monitor.getItem();
      const { id: overId } = props;
      if (draggedId !== overId) {
        const { index: overIndex } = props.findCard(overId);
        props.moveCard(draggedId, overIndex);
      }
    },
  },
  (connect) => ({
    connectDropTarget: connect.dropTarget(),
  })
)(
  DragSource(
    CARD,
    {
      beginDrag: (props) => ({
        id: props.id,
        originalIndex: props.findCard(props.id).index,
      }),
      endDrag(props, monitor) {
        const { id: droppedId, originalIndex } = monitor.getItem();
        const didDrop = monitor.didDrop();
        if (!didDrop) {
          props.moveCard(droppedId, originalIndex);
        }
      },
    },
    (connect, monitor) => ({
      connectDragSource: connect.dragSource(),
      isDragging: monitor.isDragging(),
    })
  )(CardDndComponent)
);
